var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RegisterSection',{attrs:{"show-header":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }